import BUTTONGROUP from '../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import TAB from '../../../../DOM/button/switchbutton/tab/TAB.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import Activate from '../../../../../event/Activate.js';
import Deactivate from '../../../../../event/Deactivate.js';
// Model Structure
export const tabGroupElementAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const tabGroupElementData = makeDataStruct([
    ['children', []]
]);
export const tabGroupElementModel = makeStruct([
    ['attributes', tabGroupElementAttr],
    ['data', tabGroupElementData]
]);
// Simplified Model
export function tabgroup(name, className) {
    return {
        attributes: tabGroupElementAttr(name, className),
        data: tabGroupElementData()
    };
}
/** A container for TABS */
export default class TABGROUP extends BUTTONGROUP {
    constructor(node, model) {
        super(node, model);
        this.addClass('tab-group');
    }
    /** Create a switchable tab */
    addTab(model) {
        let tab = this.addChild(new TAB(this, model));
        tab.on('activate', () => this.get(null, 'TAB').forEach((t) => {
            if (t !== tab) {
                t.do(new Deactivate(this));
            }
        })); // Deactivate Sibling Tabs
        return tab;
    }
    /** Create a nested group of tabs */
    addTabGroup(model) {
        let tabgroup = this.addChild(new TABGROUP(this, model));
        return tabgroup;
    }
    /** Triggers an Activate() event on the first TAB nested within this TABGROUP */
    activateFirstButton() {
        try {
            let [btn] = this.get();
            btn.do(new Activate(btn));
            if (typeof this.get()[1] !== 'undefined') {
                let [, nextBtn] = this.get();
                if (nextBtn.className === 'TABGROUP') {
                    nextBtn.activateFirstButton();
                }
            }
        }
        catch (err) {
            console.warn('Unable to activate first tab', err);
        }
    }
}
